module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authenticate"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Emailadres",
      "id": "testing"
    },
    on: {
      "change": function($event) {
        _vm.$emit('emailaddressEntered', _vm.emailAddress)
      }
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-10-1",
      "label": "Enter your password",
      "hint": "At least 8 characters",
      "min": "8",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "counter": ""
    },
    on: {
      "change": function($event) {
        _vm.$emit('passwordEntered', _vm.password)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.$emit('confirmed')
      }
    }
  }, [_vm._v("Bevestigen")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dddd876e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/Credentials.vue
// module id = 497
// module chunks = 1